// This utility creates a promise/resolve pair for signaling readiness across
// unrelated modules that have no other shared reference
// Call for the resolveReady once some logic is ready in one spot
// Await for the resolved promise in a different spot
export default function createReadyHandler() {
  let readyResolve;

  const promise = new Promise((resolve) => {
    readyResolve = resolve; // Retain the resolve function to be awaited on when ready
  });

  function resolveReady() {
    readyResolve(); // To be called when ready for awaited promise usages
  }

  return { promise, resolveReady };
}
